import React from "react";
import { Link } from "react-router-dom";
import { STORE_CONFIG, storeText } from "../config/storeConfig";
import "../css/policy.scss";

function PolicyPage({ policy }) {
  return (
    <main className="policy-page main">
      <article className="policy-card">
        <header className="policy-header">
          <p className="policy-kicker">{STORE_CONFIG.brand} customer policy</p>
          <h1>{policy.title}</h1>
          <p className="policy-summary">{storeText(policy.summary)}</p>
          <dl className="policy-meta">
            <div><dt>Applies from</dt><dd>{STORE_CONFIG.policyEffectiveDate}</dd></div>
            <div><dt>Operating region</dt><dd>{STORE_CONFIG.operatingRegion}</dd></div>
            <div><dt>Policy basis</dt><dd>{storeText(policy.basis)}</dd></div>
          </dl>
        </header>
        <div className="policy-body">
          {policy.sections.map((section) => (
            <section key={section.heading}>
              <h2>{storeText(section.heading)}</h2>
              {section.paragraphs && section.paragraphs.map((paragraph) => <p key={paragraph}>{storeText(paragraph)}</p>)}
              {section.bullets && <ul>{section.bullets.map((bullet) => <li key={bullet}>{storeText(bullet)}</li>)}</ul>}
            </section>
          ))}
        </div>
        <footer className="policy-contact">
          <h2>Contact</h2>
          <p>Questions about this policy can be sent to <a href={`mailto:${STORE_CONFIG.supportEmail}`}>{STORE_CONFIG.supportEmail}</a>. Include an order number where relevant, but never send a full card number or security code.</p>
          <p><Link to="/policies">Browse all policies</Link></p>
        </footer>
      </article>
    </main>
  );
}

export default PolicyPage;
